import React from "react";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function SectionSelector({ sections, parentEvent }) {
  const handleClick = (event, sid) => {
    event.preventDefault();
    parentEvent(sid);
  };

  return (
    <section className="section_selector">
      <Row>
        <div className="hotspotSelectors position-relative">
          <img src="images/hotspot-map.jpg" width={1920} height={787} alt="" />
          {/* buttons over image */}
          {sections.map((s, i) => {
            return (
              <Button
                key={s.id}
                type="button"
                onClick={(event) => handleClick(event, s.id)}
                className="position-absolute icon--plus"
                style={{ top: s.position.top, left: s.position.left }}
              ></Button>
            );
          })}
        </div>
        <div className="buttonSelectors">
          {/* Tabs at bottom */}
          {sections.map((s, i) => {
            return (
              <Button
                key={s.id}
                type="button"
                onClick={(event) => handleClick(event, s.id)}
              >
                {s.title}
              </Button>
            );
          })}
        </div>
      </Row>
    </section>
  );
}

export default SectionSelector;
